export default __webpack_public_path__ + "static/media/shop-money.709354f4.svg";